import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEllipsisV,
  faChevronDown,
  faChevronUp,
  faTimes,
  faExpandAlt,
  faUser,
  faCheck,
  faPause,
  faEquals,
  faTrashAlt,
  faLock,
  faSortDown,
  faSort,
  faSortUp,
  faSpinner,
  faExclamationTriangle,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';

// FaSolid
library.add(
  faChevronUp,
  faExpandAlt,
  faChevronDown,
  faTimes,
  faEllipsisV,
  faUser,
  faCheck,
  faPause,
  faEquals,
  faTrashAlt,
  faLock,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faExclamationTriangle,
  faChevronLeft,
  faChevronRight
);

import { dom } from '@fortawesome/fontawesome-svg-core';
dom.watch();
